import { render } from "./PianoRoll.vue?vue&type=template&id=13744842&scoped=true"
import script from "./PianoRoll.vue?vue&type=script&lang=js"
export * from "./PianoRoll.vue?vue&type=script&lang=js"

import "./PianoRoll.vue?vue&type=style&index=0&id=13744842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13744842"]])

export default __exports__